import React from "react";
import { ProposedFtlRoute } from "./ProposedFtlRoute";
import { EditableDateCell } from "./EditableDateCell";
import { RouteState } from "../../../Project/ViewModel/RouteState";
import { LaunchDateCellProps } from "./DateCellProps";
import { useIsUserInRoles } from "../../../Auth/useIsUserInRoles";
import { AuthorizationPolicies } from "../../../Auth/AuthorizationPolicy";

const ReturnLaunchDateCell = ({ gridCellProps, handleDateChange }: LaunchDateCellProps) => {
  const { dataItem } = gridCellProps;
  const proposedFtlRoute = dataItem as ProposedFtlRoute;
  const editable =
    proposedFtlRoute?.LaunchDate !== undefined &&
    proposedFtlRoute?.Roundtrip &&
    proposedFtlRoute?.RouteState !== RouteState.Launched;

  const isUserInAdminNetworkRole = useIsUserInRoles(AuthorizationPolicies.RequireAdminNetworkRoles);
  return (
    <EditableDateCell
      gridCellProps={gridCellProps}
      handleDatePickerChange={handleDateChange}
      editable={(editable ?? false) && isUserInAdminNetworkRole}
      highlightValue={proposedFtlRoute?.ReturnLaunchDateIsCalculated ?? false}
      launchDateKey="ReturnLaunchDate"
      disabled={!isUserInAdminNetworkRole}
    />
  );
};

export const returnLaunchDateCell = ({ gridCellProps, handleDateChange }: LaunchDateCellProps) => {
  return <ReturnLaunchDateCell gridCellProps={gridCellProps} handleDateChange={handleDateChange} />;
};
